import { render, staticRenderFns } from "./HealthCenterSetup.vue?vue&type=template&id=07a11875&scoped=true&"
var script = {}
import style0 from "./HealthCenterSetup.vue?vue&type=style&index=0&id=07a11875&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a11875",
  null
  
)

export default component.exports